'use client';

import { useEffect, useState } from 'react';

const LARGE_DOBI_SPEND_CONFIRM_ENABLED_KEY = 'dobidobi.largeDobiSpendConfirm.enabled';
const LARGE_DOBI_SPEND_CONFIRM_EVENT = 'dobidobi:large-dobi-spend-confirm-preference';

function readEnabledFromStorage(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }
  return window.localStorage.getItem(LARGE_DOBI_SPEND_CONFIRM_ENABLED_KEY) !== 'false';
}

export function isLargeDobiSpendConfirmEnabled(): boolean {
  return readEnabledFromStorage();
}

export function setLargeDobiSpendConfirmEnabled(enabled: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.setItem(LARGE_DOBI_SPEND_CONFIRM_ENABLED_KEY, enabled ? 'true' : 'false');
  window.dispatchEvent(new CustomEvent(LARGE_DOBI_SPEND_CONFIRM_EVENT, { detail: { enabled } }));
}

export function useLargeDobiSpendConfirmEnabled(): [boolean, (enabled: boolean) => void] {
  const [enabled, setEnabledState] = useState(true);

  useEffect(() => {
    const sync = () => setEnabledState(readEnabledFromStorage());
    sync();
    window.addEventListener('storage', sync);
    window.addEventListener(LARGE_DOBI_SPEND_CONFIRM_EVENT, sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener(LARGE_DOBI_SPEND_CONFIRM_EVENT, sync);
    };
  }, []);

  const setEnabled = (nextEnabled: boolean) => {
    setLargeDobiSpendConfirmEnabled(nextEnabled);
    setEnabledState(nextEnabled);
  };

  return [enabled, setEnabled];
}
